import { Application } from 'src/portaljs/constants/application';
import { PortalApp } from './portal-app';
import { MonoTypeOperatorFunction, retry, throwError, timer } from 'rxjs';

export class Util {

  public static readonly orderedApplicationList = [
    Application.DASHBOARD, Application.DESTINY, Application.CLM, Application.DD, Application.COLLECTIONS, Application.DISCOVER_MANAGER, Application.FM, // Destiny
    Application.MASTERLIBRARY_HELPDESK, Application.MASTERLIBRARY_ITAM, // Technology
    Application.TITLEWAVE, Application.DESTINY_EXPRESS, // Shop
    Application.FOLLETT_COMMUNITY, // Support
    Application.MASTERLIBRARY_WORKORDERS, Application.MASTERLIBRARY_SCHEDULES, Application.MASTERLIBRARY_DRAWINGS // Facilities
  ];

  public static getSiteGuidFromContext(guid: string) : string {
    if (guid != null && guid.indexOf('site:') >= 0) {
      guid = guid.substring(guid.indexOf('site:') + 5);
    }
    return guid;
  }

  public static getBaseUserGuid(userGuid: string) : string {
    let baseGuid: string;
    if (userGuid) {
      const ctx = userGuid.split('.');
      baseGuid = ctx[ctx.length - 1 ];
    }
    return baseGuid;
  }

  public static orderPortalApps(apps: PortalApp[] = []): PortalApp[] {
    return apps.sort((a1, a2) => Util.orderedApplicationList.indexOf(a1.app) - Util.orderedApplicationList.indexOf(a2.app));
  }

  public static getApplicationKey(app: Application): string {
    return Object.keys(Application).filter(x => Application[x as keyof typeof Application] === app)[0];
  }

  public static getReadableApplicationName(app: Application): string {
    if (app === Application.CLM) {
      return 'Classroom Library Manager';
    } else {
      return app;
    }
  }



  public static getRetryPipe(retries: number, delayMs: number, statusCode: number): MonoTypeOperatorFunction<any> {
    return retry({
      count: retries,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      delay: ((error: any, retryCount?: number) => {

        if (error.status === statusCode) {
          return timer(delayMs);
        }
        return throwError(() => error);
      })
    });
  }

  public static getEnumFromString(enumObj: any, str: string): any {
    for (const key in enumObj) {
      if (enumObj[key] === str) {
        return enumObj[key];
      }
    }
    return undefined;
  }

}
